import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

import getProjectRequest from 'api/requests/project/getProject';
import editProjectRequest from 'api/requests/project/editProject';
import getPayoutDetailsRequest from 'api/requests/payout/getPayoutDetails';
import getAvailablePayoutAmountsRequest from 'api/requests/payout/getAvailablePayoutAmounts';
import sendReceiptRequest from 'api/requests/receipt/sendReceipt';
import createPayoutRequest from 'api/requests/payout/createPayout';

async function getProject() {
  try {
    const { data } = await getProjectRequest(axios);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

// eslint-disable-next-line no-unused-vars
async function updateProject({ commit }, payload) {
  try {
    await editProjectRequest(axios, payload);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

async function getPayoutDetails({ commit }, payload) {
  try {
    const { data } = await getPayoutDetailsRequest(axios, payload);

    commit('SET_PAYOUT_DETAILS', data);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

async function getAvailablePayoutAmounts({ commit }) {
  try {
    const { data } = await getAvailablePayoutAmountsRequest(axios);

    commit('SET_AVAILABLE_PAYOUT_AMOUNTS', data);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

// eslint-disable-next-line no-unused-vars
async function sendReceipt({ commit }, payload) {
  try {
    const { data } = await sendReceiptRequest(axios, payload);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

// eslint-disable-next-line no-unused-vars
async function createPayout({ commit }, payload) {
  try {
    const { data } = await createPayoutRequest(axios, payload);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  getProject,
  updateProject,
  getPayoutDetails,
  getAvailablePayoutAmounts,
  sendReceipt,
  createPayout,
};
